import React from 'react';
import { Can } from '@/components/common';
import { theme } from '@/styles/theme';
import { Delete, Edit } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';

interface ReportSubscriptionsTableActionsProps {
  id: string;
  // eslint-disable-next-line no-unused-vars
  onEditReportSubscription: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onDeleteReportSubscription: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onEditReportSubscriptionMouseEnter: (id: string) => void;
}

export function ReportSubscriptionsTableActions({
  id,
  onEditReportSubscription,
  onDeleteReportSubscription,
  onEditReportSubscriptionMouseEnter,
}: ReportSubscriptionsTableActionsProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="center"
    >
      <Can permissions={['report_subscriptions_update']}>
        <Tooltip title="Alterar" disableInteractive>
          <IconButton
            onMouseEnter={() => onEditReportSubscriptionMouseEnter(id)}
            onClick={() => onEditReportSubscription(id)}
            size="small"
            sx={{
              '&:hover': {
                color: theme.palette.primary.main,
              },
            }}
          >
            <Edit fontSize="small" />
          </IconButton>
        </Tooltip>
      </Can>
      <Can permissions={['report_subscriptions_delete']}>
        <Tooltip title="Excluir" disableInteractive>
          <IconButton
            onClick={() => onDeleteReportSubscription(id)}
            size="small"
            sx={{
              '&:hover': {
                color: theme.palette.error.main,
              },
            }}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Tooltip>
      </Can>
    </Stack>
  );
}
